// ImportaDocumento.js

import React, { useState, useEffect } from 'react';
import { Modal } from '@mui/material';
import styled from 'styled-components';
import SearchInput from './SearchInput';
import DatePicker from './DatePicker';
import DocumentTable from './DocumentTable';
import ModalLoading from '../../../ModalLoading';
import { importConfigs } from './importConfigs';
import { cores } from '../../../../styles/styleUtils';

// ... (styled components não foram alterados, mas adicionei os botões novos)
const Container = styled.div`
 padding: 20px;
 width: 100%;
 max-width: 100%;
 height: 90%;
 max-height: 90%;
 margin: 25px auto;
 background: linear-gradient(180deg, ${cores.painelTopo} 0%, ${cores.painelBase} 100%);
 border-top: 4px solid ${cores.laranja};
 border-radius: 8px;
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
 display: flex;
 gap: 10px;
 margin-bottom: 15px;
`;

const Button = styled.button`
  font-size: 0.9rem;
  border: none;
  color: white;
  cursor: pointer;
  border-radius: 8px;
  padding: 0 20px;
  height: 45px;
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const ConfirmButton = styled(Button)`
  background-color: ${cores.laranja};
  &:hover {
    background-color: ${cores.laranjaEscuro};
  }
`;

const ClearButton = styled(Button)`
  background-color: ${cores.chumbo};
`;

const ImportaDocumento = ({ open, handleClose, onSelect, type, filtroExtra }) => {
  const config = importConfigs[type];
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  // 1. Alterado para um array para suportar multi-seleção
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);

  const fetchData = async () => {
    setModalLoading(true);
    try {
      const result = await config.fetchFunction({});
      setData(result);
    } catch (err) {
      window.alert('Erro ao buscar dados da API');
      console.error(err);
    } finally {
      setModalLoading(false);
    }
  };

  useEffect(() => {
    if (open) { // Busca os dados somente quando o modal abre
      fetchData();
    } else { // Limpa o estado quando o modal fecha
      setData([]);
      setSelectedDocs([]);
      setSearchTerm('');
    }
  }, [open]);

  // 2. useEffect atualizado para filtrar por cliente selecionado
  useEffect(() => {
    let filtered = data;

    // Filtro extra opcional (ex.: escopo por usuário em "Vendas não lançadas")
    if (filtroExtra) {
      filtered = filtered.filter(filtroExtra);
    }

    // Filtro por cliente (quando há seleção)
    if (selectedDocs.length > 0) {
      // Assumindo que o objeto cliente está em 'item.cliente._id'
      const selectedClientId = selectedDocs[0].cliente._id;
      filtered = filtered.filter(item => item.cliente._id === selectedClientId);
    }

    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(item => config.filterFn(item, term));
    }

    if (selectedDate) {
      filtered = filtered.filter(item => {
        const itemDate = new Date(item.data).toISOString().split('T')[0];
        return itemDate === selectedDate;
      });
    }

    setFilteredData(filtered);
  }, [searchTerm, selectedDate, data, selectedDocs, filtroExtra]); // Adicionado `selectedDocs` como dependência

  // 3. Nova função para gerenciar a seleção de itens
  const handleSelect = (doc) => {
    if (selectedDocs.length > 0 && selectedDocs[0].cliente._id !== doc.cliente._id) {
        alert("Você só pode selecionar propostas do mesmo cliente.");
        return;
    }

    setSelectedDocs((prev) => {
      const isSelected = prev.some((item) => item._id === doc._id);
      if (isSelected) {
        return prev.filter((item) => item._id !== doc._id); // Remove
      }
      return [...prev, doc]; // Adiciona
    });
  };

  const handleClearSelection = () => {
    setSelectedDocs([]);
  }

  // 4. Lógica de confirmação atualizada
  const handleConfirm = () => {
    if (selectedDocs.length === 0) {
      alert('Selecione ao menos um documento');
      return;
    }
    onSelect(selectedDocs);
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Container>
        <Row>
          <SearchInput value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
          <DatePicker value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} />
          {selectedDocs.length > 0 && (
             <ClearButton onClick={handleClearSelection}>Limpar Seleção</ClearButton>
          )}
          <ConfirmButton onClick={handleConfirm} disabled={selectedDocs.length === 0}>
            Confirmar ({selectedDocs.length})
          </ConfirmButton>
        </Row>
        <DocumentTable
          data={filteredData}
          // 5. Passando o array de IDs e a nova função de seleção
          selectedIds={selectedDocs.map(doc => doc._id)}
          onSelect={handleSelect}
          titles={config.tableTitles}
          fields={config.tableFields}
        />
        {modalLoading && <ModalLoading open={modalLoading} />}
      </Container>
    </Modal>
  );
};

export default ImportaDocumento;